import PropTypes from 'prop-types';
import { alpha, Box, Stack, Typography } from '@mui/material';

const styles = {
  item: {
    position: 'relative',
    cursor: 'pointer',
    height: '100%',
    flex: 1,
  },
  disabledItem: { cursor: 'default' },
  cursor: ({ palette }) => ({
    position: 'absolute',
    inset: 0,
    zIndex: 1,
    border: `4px solid ${palette.primary.main}`,
    backgroundColor: alpha(palette.primary.main, 0.3),
  }),
  value: ({ breakpoints }) => ({
    fontSize: 24,
    [breakpoints.up('md')]: {
      fontSize: 32,
    },
  }),
};

export const QualityEvaluationItem = ({
  hideValue = false,
  value = null,
  isSelected = false,
  cursorOffset = 0,
  handleClick = null,
  color,
}) => {
  return (
    <Stack
      id={`evaluation-item-${value}`}
      justifyContent="center"
      alignItems="center"
      role={handleClick ? 'button' : 'listitem'}
      onClick={handleClick}
      sx={[styles.item, !handleClick && styles.disabledItem, { backgroundColor: color }]}
    >
      {!hideValue && (
        <Typography variant="h5" component="p" color="text.disabled" sx={styles.value}>
          {value}
        </Typography>
      )}

      {isSelected && <Box sx={[styles.cursor, { transform: `translateX(${cursorOffset * 100}%)` }]} />}
    </Stack>
  );
};

QualityEvaluationItem.propTypes = {
  hideValue: PropTypes.bool,
  value: PropTypes.number,
  isSelected: PropTypes.bool,
  cursorOffset: PropTypes.number,
  handleClick: PropTypes.func,
  color: PropTypes.string.isRequired,
};
